import React from 'react';
// Components
import Sales from 'components/common/Sales';

const OrganizationStoreSales: React.FC = () => {
  return <Sales />;
};

export default OrganizationStoreSales;
